import { render, staticRenderFns } from "./SupplierRawMaterialLegislativeStatus.vue?vue&type=template&id=2c0a639a&scoped=true&"
import script from "./SupplierRawMaterialLegislativeStatus.vue?vue&type=script&lang=js&"
export * from "./SupplierRawMaterialLegislativeStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0a639a",
  null
  
)

export default component.exports